import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
import { Link } from 'react-router-dom'
import NavbarOffcanvas from './NavbarOffcanvas'
import Menu from '../../assets/icons/header/menu.svg'
import Logo from '../../assets/logo/logo.png'
import { CLASSES } from '../../assets/styles/styles'

function HomeHeader() {
  const [showMenu, setShowMenu] = React.useState(false)

  return (
    <Navbar
      fixed='top'
      collapseOnSelect
      expand='lg'
      style={{
        background: '#495C2D',
        height: 60,
      }}
      className='navbar'
    >
      <Container fluid>
        <Container className='position-relative'>
          <div className={CLASSES.content_between}>
            <Link className='navbar-link text-white' to={'/'}>
              <Image style={{ width: 230 }} src={Logo} />
            </Link>

            <div>
              <div className='d-lg-none'>
                <Navbar.Toggle
                  aria-controls='responsive-navbar-nav'
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <Image style={{ minWidth: 24, width: '12%' }} src={Menu} />
                </Navbar.Toggle>
              </div>
              <NavbarOffcanvas showMenu={showMenu} setShowMenu={setShowMenu} />
            </div>
          </div>
        </Container>
      </Container>
    </Navbar>
  )
}

export default HomeHeader
